<script>
  import appConfig from "@/app.config";
  import {
    http
  } from '@/helpers/easyindustriaapi/config';
    import Layout from "@/views/layouts/main"
  import PageHeader from "@/components/page-header";
   import List from "./list";
   import Insert from "./insert";
  import Edit from "./edit";
  import {
    canDeleteResponsible,
    canEditResponsible,
    canInsertResponsible,
    canViewResponsible,
  } from './responsiblePermissions';
  import { getResponsibleRequestErrorMessage } from './responsibleErrors';
  export default {
    page: {
      title: 'Lista de clientes',
      meta: [{
        name: 'description',
        content: appConfig.description
      }],
    },
    components: {
      List,
      Insert,
      Edit,
      PageHeader,
      Layout
    },
    data() {
      return {
        currentUser: null,
        currentEmpresa: null,
        currentResponsible: {},
        responsibles: [],
        inserindo: false,
        editando: false,
        titleBody: 'Lista de Responsáveis',
        listUsers: [],
        items: [{
            text: "Dashboard",
            href: "/",
          },
          {
            text: "Responsáveis",
            href: "/",
            active: true,
          },
          {
            text: "Incluir Responsáveis",
            href: "/cadastros/profissionais",
            active: true,
          }
        ],
      }
    },
    computed: {
      isHide() {
        return (!this.inserindo && !this.editando);
      },
      canViewResponsible() {
        return canViewResponsible(this.currentUser);
      },
      canInsertResponsible() {
        return canInsertResponsible(this.currentUser);
      },
      canEditResponsible() {
        return canEditResponsible(this.currentUser);
      },
      canDeleteResponsible() {
        return canDeleteResponsible(this.currentUser);
      },
    },
    created() {
      this.currentUser = JSON.parse(localStorage.getItem('user'));
      this.currentEmpresa = JSON.parse(localStorage.getItem('currentEmpresa'));
    },
    mounted() {
      this.getData();
    },
    methods: {
      makeToast(variant = null, message = 'Error generic') {
        this.counter++;
        this.$bvToast.toast(message, {
          title: `Notificação`,
          toaster: 'b-toaster-bottom-right',
          variant: variant,
          solid: true,
          appendToast: true
        });
      },
      changeHomeTitle(newTitle) {
        this.titleBody = newTitle;
      },
      back() {
        this.inserindo = false;
        this.editando = false;
      },
      onLoader() {
        if (document.getElementById("preloader").style.display === "none") {
          document.getElementById("preloader").style.display = "block";
          document.getElementById("status").style.display = "block";
        }
      },
      offLoader() {
        if (document.getElementById("preloader").style.display === "block") {
          setTimeout(function() {
            document.getElementById("preloader").style.display = "none";
            document.getElementById("status").style.display = "none";
          }, 2500);
        }
      },
      async getData() {
        this.onLoader();
        try {
          let response = await http.get('/responsible?empresa_id=' + this.currentEmpresa.id);
          if (response.status === 200) {
            this.responsibles = response.data.responsibles;
            this.listUsers = response.data.users;
            console.log(this.listUsers);
            this.offLoader();
          }
        } catch (error) {
          this.makeToast(
            'danger',
            getResponsibleRequestErrorMessage(error, 'visualizar')
          );
          this.offLoader();
        }
      },
      insert() {
        this.inserindo = !this.inserindo;
      },
      edit(local) {
        this.currentResponsible = local;
        this.editando = !this.editando;
      },
      async doPost(plano) {
        plano.empresa_id = this.currentEmpresa.id;
        let response;
        try {
          response = await http.post('/responsible?empresa_id=' + this.currentEmpresa.id, plano);
        } catch (error) {
          this.offLoader();
          this.makeToast('danger', getResponsibleRequestErrorMessage(error, 'incluir'));
          return;
        }
        if (response.status === 200) {
          this.getData();
          this.back();
          this.makeToast('success', 'Registro incluído');
        }
      },
      async doPut(responsible) {
        this.onLoader();
        responsible.user_id = this.currentUser.id;
        let response;
        try {
          response = await http.put('/responsible/' + responsible.id + '?empresa_id=' + this.currentEmpresa.id, responsible);
        } catch (error) {
          this.offLoader();
          this.makeToast('danger', getResponsibleRequestErrorMessage(error, 'alterar'));
          return;
        }
        if (response.status === 200) {
          this.getData();
          this.back();
          this.makeToast('success', 'Registro alterado');
        }
      },
      async doDelete(plano) {
        this.onLoader();
        plano.empresa_id = this.currentEmpresa.id;
        let response;
        try {
          response = await http.delete('/responsible/' + plano.id + '?empresa_id=' + this.currentEmpresa.id, plano);
        } catch (error) {
          this.offLoader();
          this.makeToast('danger', getResponsibleRequestErrorMessage(error, 'excluir'));
          return;
        }
        if (response.status === 200) {
          this.getData();
          this.back();
          this.makeToast('warning', 'Registro excluído');
        }
      },
    },
  }
</script>

<template>
  <Layout> 
  <PageHeader :title="titleBody" :items="items" />
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-12 col-md-6"></div>
            <div class="col-sm-12 col-md-6 text-md-right">
              <button @click="insert()" v-if="isHide && canInsertResponsible" type="button" class="btn btn-success">+ Incluir Responsável</button>
              <button @click="back()" v-if="!isHide" class="btn btn-secondary">Voltar</button>
            </div>
          </div>
        </div>
        
        <div class="card-body" v-if="!isHide">
          <Insert
           v-if="inserindo"
           :currentEmpresa="currentEmpresa"
           @newTitle="changeHomeTitle"
           @doPost="doPost "
          />
          <Edit
           v-if="editando"
           :currentEmpresa="currentEmpresa"
           :oldLResponsible="currentResponsible"
           :users="listUsers"
           @newTitle="changeHomeTitle"
           @doPut="doPut"
          />
        </div>
        <List v-if="isHide"
         :currentEmpresa="currentEmpresa"
         :listResponsibles="responsibles"
         :hide="isHide"
         :can-view="canViewResponsible"
         :can-edit="canEditResponsible"
         :can-delete="canDeleteResponsible"
         @newTitle="changeHomeTitle"
         @edit="edit"
         @doDelete="doDelete"
        />
      </div>
    </div>
  </div>
  </Layout> 
</template>